import { render, staticRenderFns } from "./Statement_by_customer.vue?vue&type=template&id=1c8a32d7&"
import script from "./Statement_by_customer.vue?vue&type=script&lang=js&"
export * from "./Statement_by_customer.vue?vue&type=script&lang=js&"
import style0 from "./Statement_by_customer.vue?vue&type=style&index=0&id=1c8a32d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports